<template>
    <option v-if="nullable" :value="null">{{ nullLabel }}</option>
    <option
        v-for="option in $enumOptions(group)"
        :key="`${group}-key-${option[0]}`"
        :value="option[0]"
    >
        {{ option[1] }}
    </option>
</template>
<script>
export default {
    props: {
        nullable: {
            type: Boolean,
            default: false,
        },
        nullLabel: {
            type: String,
            default: "",
        },
        group: {
            type: String,
            required: true,
        },
    },
};
</script>
